import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    return (
        // <div style={{ display: "flex" }}>
        //     <Sidebar />
        //     <div style={{ flex: 1 }}>
        //         <Header />
        //         <div style={{ padding: "20px" }}>
        //             <Outlet />
        //         </div>
        //     </div>
        // </div>
        <>
            <div class="wrapper">

                <div class="sidenav-menu" >
                    <a href="#" class="logo">
                        <span class="logo logo-light">
                            <span class="logo-lg"><img src="https://erp.empowerplus.in/files/ep%20logo.png" alt="logo" /></span>
                            <span class="logo-sm"><img src="https://erp.empowerplus.in/files/ep%20logo.png" alt="small logo" /></span>
                        </span>

                        <span class="logo logo-dark">
                            <span class="logo-lg"><img src="https://erp.empowerplus.in/files/ep%20logo.png" alt="dark logo" /></span>
                            <span class="logo-sm"><img src="https://erp.empowerplus.in/files/ep%20logo.png" alt="small logo" /></span>
                        </span>
                    </a>

                    <button class="button-on-hover">
                        <i class="ti ti-menu-4 fs-22 align-middle"></i>
                    </button>


                    <button class="button-close-offcanvas" onClick={() => window.layoutHelper?.collapseSidebar()}>
                        <i class="ti ti-x align-middle"></i>
                    </button>





                    <ul class="side-nav" >

                        <Sidebar />

                    </ul>
                </div>

                {/* <header class="app-topbar">
                </header> */}
                {/* <Header /> */}

                <header class="app-topbar">
                    <Header />
                </header>

                <div class="content-page">
                    <div class="container-fluid">
                        <Outlet />
                    </div>
                </div>

            </div>
        </>
    );
};

export default MainLayout;
